namespace $.$$ {
	type $shm_dashboard_admin_wordstat_stats = {
		tasks?: number
		items?: number
		requests?: number
	}

	export class $shm_dashboard_admin_wordstat extends $.$shm_dashboard_admin_wordstat {
		stats_data() {
			const response = this.$.$mol_fetch.response( `${ this.$.$shm_pb.url() }/api/hitalama/wordstat/stats`, {
				headers: this.$.$shm_pb.admin_headers(),
			} )
			if( !response.ok() ) throw new Error( response.message() )
			return response.json() as $shm_dashboard_admin_wordstat_stats
		}

		regular_tasks() { return String( this.stats_data().tasks || 0 ) }
		regular_items() { return String( this.stats_data().items || 0 ) }
		daily_requests() { return String( this.stats_data().requests || 0 ) }
	}
}
